import { URLS } from '@/pages/urls'
import { Button, Text } from '@/ui-kit'
import { SCREEN_SIZE, useMediaQuery } from '@/ui-kit/media'
import { useLocalStorage } from '@/utils/useLocalStorage'
import { Trans } from '@lingui/react/macro'

export const CookiesDialog = () => {
  const [showDialog, setShowDialog] = useLocalStorage('DH_COOKIES_SHOW', true)
  const isMobile = useMediaQuery(SCREEN_SIZE.MOBILE)

  return (
    !isMobile &&showDialog && (
      <div className="fixed bottom-10 left-10 z-[1] w-[440px] max-md:bottom-2 max-md:left-5 max-md:w-[calc(100vw-40px)]">
        <div className="relative overflow-hidden rounded-xl bg-[var(--colorBlackToWhite)] px-6 pt-5 pb-8 shadow-md">
          <img className="absolute right-0 bottom-0" width={72} src="/images/cookie.webp" alt="" />
          <Text type="subtitle-semibold">
            <Trans>Datahive.ai uses cookies</Trans>
          </Text>
          <Text className="mt-2 block text-[var(--colorGray80to90)]">
            <Trans>
              Cookies help our site function properly and securely. To learn more, please view our{' '}
              <a
                href={URLS.PRIVACY_POLICY}
                target="_blank"
                rel="noreferrer"
                className="underline hover:text-[var(--color)]"
              >
                Privacy Policy.
              </a>
            </Trans>
          </Text>
          <Button size="small" className="mt-6" onClick={() => setShowDialog(false)}>
            <Trans>Accept all</Trans>
          </Button>
        </div>
      </div>
    )
  )
}
